/**
 * @generated SignedSource<<8531576d5a8ced028c530226ba035da5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchAssetsObject_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultAssetsObject";
  readonly description: string;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly objectEntity: {
    readonly avatar: {
      readonly url48: string | null | undefined;
    } | null | undefined;
    readonly links: {
      readonly web: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly objectSchemaEntity: {
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly " $fragmentType": "searchAssetsObject_AtlassianSearchPage";
};
export type searchAssetsObject_AtlassianSearchPage$key = {
  readonly " $data"?: searchAssetsObject_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchAssetsObject_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchAssetsObject_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "concreteType": "AssetsSchema",
      "kind": "LinkedField",
      "name": "objectSchemaEntity",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    },
    {
      "concreteType": "AssetsObject",
      "kind": "LinkedField",
      "name": "objectEntity",
      "plural": false,
      "selections": [
        {
          "concreteType": "AssetsAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "url48"
            }
          ]
        },
        {
          "concreteType": "AssetsLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "web"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultAssetsObject"
};

(node as any).hash = "0eea183c12ea41b63de705e78bddf666";

export default node;
